import {
    POST_LOADING,
    POST_LOADED,
    POST_CREATED,
    POST_SINGLE_LOADING,
    POST_SINGLE_FAILED,
    POST_DELETED,
    CHANGE_LIST
} from '../actions/journal';


const initialState = {
    isLoading: false,
    posts: [],
    totalPosts: 0,
    change: false,
    errors: null,
    historyEnabled: false,
    currentSelection:null,
    details: {
        isLoading: false,
        isSuccess: false,
        errors: null
    }
}

const showcaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_LOADING:
            return {
                ...state,
                isLoading: true
            }
        case POST_LOADED:
            // posts: [
            //     ...state.posts,
            //     ...action.payload.posts
            // ],

            return {
                ...state,
                isLoading: false,
                posts: action.payload.posts,
                totalPosts: action.payload.totalPosts,
                historyEnabled: action.payload.historyEnabled,
                errors: null
            }
        case POST_DELETED:
            return {
                ...state,
                posts: state.posts.filter(postDetails => postDetails.reflection_id !== action.payload.postId)
            }
        case POST_CREATED:
            return {
                ...state,
                new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                }
            }
        case POST_SINGLE_LOADING:
            return {
                ...state
            }
        case POST_SINGLE_FAILED:
            return {
                ...state
            }
        case CHANGE_LIST:
            return { ...state, change: action.payload.change }
        case 'filterStatus':
            return { ...state, currentSelection: action.payload }
        default:
            return state;
    }
};

export default showcaseReducer;
